import React, { useState, createContext, useReducer, useEffect } from 'react';
import {filterReducer, DEFAULT_FILTERS} from "reducers/merchandising/filterReducer";
import {getFilterLabel} from "domain/helpers/filterTranslations";

export const FilterContext = createContext();
export const FilterDispatchContext = createContext();

export function FilterProvider({ children, initialFilters = DEFAULT_FILTERS }) {

    const [filters, dispatch] = useReducer(filterReducer, initialFilters);
    const [filterParams, setFilterParams] = useState();

    useEffect(() => {
        let params = {
            filterRetailers: [],
            filterCorners: [],
            filterCategories: [],
            filterGenders: [],
            filterBrands: [],
            filterOptions: [],
            filterStatus: null,
            filterValidated: null,
            filterOnEshop: null,
            filterInStock: null,
            filterLimitedDistribution: null,
            filterPriceMin: null,
            filterPriceMax: null,
            filterDiscountMin: null,
            filterDiscountMax: null,
            filterSalesMin: null,
            filterBenchmark: null,
            filterDemand: null,
            filterChannels: [],
        };

        filters.map((filter) => {
            switch (filter['@type']) {
                case 'Retailer': {
                    params.filterRetailers.push(filter.id);
                    break;
                }
                case 'Corner': {
                    params.filterCorners.push(filter.id);
                    break;
                }
                case 'Category': {
                    params.filterCategories.push(filter.id);
                    break;
                }
                case 'Gender': {
                    params.filterGenders.push(filter.id);
                    break;
                }
                case 'Brand': {
                    params.filterBrands.push(filter.id);
                    break;
                }
                case 'Status': {
                    params.filterStatus = (filter.id === 'active' ? true : false);
                    break;
                }
                case 'Validated': {
                    params.filterValidated = (filter.id === 'valid' ? true : false);
                    break;
                }
                case 'OnEshop': {
                    params.filterOnEshop = (filter.id === 'yes' ? true : false);
                    break;
                }
                case 'Stock': {
                    params.filterInStock = (filter.id === 'instock' ? true : false);
                    break;
                }
                case 'LimitedDistribution': {
                    params.filterLimitedDistribution = (filter.id === 'limiteddistribution' ? true : false);
                    break;
                }
                case 'PriceMin': {
                    params.filterPriceMin = Number(filter.value);
                    break;
                }
                case 'PriceMax': {
                    params.filterPriceMax = Number(filter.value);
                    break;
                }
                case 'DiscountMin': {
                    params.filterDiscountMin = Number(filter.value);
                    break;
                }
                case 'DiscountMax': {
                    params.filterDiscountMax = Number(filter.value);
                    break;
                }
                case 'SalesMin': {
                    params.filterSalesMin = Number(filter.value);
                    break;
                }
                case 'Benchmark': {
                    params.filterBenchmark = filter.value;
                    break;
                }
                case 'Demand': {
                    params.filterDemand = filter.value;
                    break;
                }
                case 'RetailerOptionValue':
                case 'OptionValue': {
                    params.filterOptions.push({'optionId': filter.optionId, 'retailerOptionValueId': filter.id});
                    break;
                }
                case 'Channel': {
                    params.filterChannels.push(filter.id);
                    break;
                }
                default: {
                    throw Error('Unknown filter type : ' + filter['@type']);
                }
            }
        });

        setFilterParams(params);

    }, [filters]);

    return (
        <FilterContext.Provider value={{filters, filterParams}}>
            <FilterDispatchContext.Provider value={dispatch}>
                {children}
            </FilterDispatchContext.Provider>
        </FilterContext.Provider>
    );
}
